<template>
  <div class="b-booking-user-profile">
    <div class="b-booking-user-profile__header">
      <div class="b-booking-user-profile__avatar">
        <img
          v-if="store.accountData && store.accountData.avatar"
          :src="store.accountData.avatar.url"
          :alt="store.accountData.avatar.alt" />
        <img v-else src="/assets/imgs/icons/no-avatar.png" alt="" />
      </div>

      <div class="b-booking-user-profile__info">
        <div class="b-booking-user-profile__welcome">
          {{ dictionary.userProfileWelcome }}
          <div class="e-label e-label--bg">
            {{ store.accountData ? store.accountData.clubName : "" }}
          </div>
        </div>

        <div class="b-booking-user-profile__firstname">
          {{ store.accountData ? store.accountData.firstName : null }}
        </div>
      </div>
    </div>

    <div class="b-booking-user-profile__points">
      <ul>
        <li v-if="store.getUserPoints > 0">
          <span class="b-booking-user-profile__points__text">{{ dictionary.currentPointsText }}</span>
          <span class="b-booking-user-profile__points__num">{{ store.getUserPoints }}</span>
        </li>
        <li v-if="store.getTotalUsedPoints > 0">
          <span class="b-booking-user-profile__points__text">{{ dictionary.userProfileUsedLabel }}</span>
          <span class="b-booking-user-profile__points__num">-{{ store.getTotalUsedPoints  }}</span>
        </li>
      </ul>
    </div>

    <div class="b-booking-user-profile__section-title">
      {{ dictionary.userProfileSectionTitle }}
    </div>

    <hr />

    <ul>
      <li>
        <label for="">{{ dictionary.userProfileFullNameLabel }}</label>
        <div class="value">{{ fullName }}</div>
      </li>
      <li>
        <label for="">{{ dictionary.userProfileEmailLabel }}</label>
        <div class="value">
          {{ store.accountData ? store.accountData.email : null }}
        </div>
      </li>
      <li>
        <label for="">{{ dictionary.userProfilePhoneLabel }}</label>
        <div class="value">
          {{ store.accountData ? store.accountData.mobilePhone : null }}
        </div>
      </li>
    </ul>

    <div class="b-booking-user-profile__buttons">
      <button type="button" class="btn btn-dropdown" @click="onClick">
        {{ dictionary.buttonEditUserProfileText }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue'
import { useBookingStore } from './../../../store/BookingStore'

const { dictionary } = getCurrentInstance().appContext.config.globalProperties
const store = useBookingStore()

const emit = defineEmits(['click-edit'])

const fullName = computed(() => {
  const { accountData } = store

  if (!accountData) {
    return false
  }
  const { firstName, lastName } = store.accountData
  return `${firstName} ${lastName}`
})

const onClick = () => {
  emit('click-edit')
}
</script>
